import React from 'react'

import { CarouselHeader } from '../../atoms/carouselHeader'
import { AnimatedRectangleFallback } from '../../atoms/animatedFallbacks'
import {
  StyledInnerMobileWrapperFallback,
  StyledOuterMobileWrapper,
} from './styles'

const LogosCarouselFallback = () => {
  const numOfItems = 6

  return (
    <StyledOuterMobileWrapper>
      <CarouselHeader />
      <StyledInnerMobileWrapperFallback length={numOfItems}>
        {Array.apply(null, Array(numOfItems)).map((_, i) => (
          <div key={`logo-fallback-${i}`}>
            <AnimatedRectangleFallback />
          </div>
        ))}
      </StyledInnerMobileWrapperFallback>
    </StyledOuterMobileWrapper>
  )
}

export { LogosCarouselFallback }
